import { Workspace } from '~/utils/workspaceSelection'

/**
 * Check if the current workspace user is an admin.
 * Note: Role is workspace-scoped, not user-scoped.
 */
export function isWorkspaceAdmin(workspace: Workspace | null): boolean {
  return workspace?.is_admin ?? false
}
